"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppClientAccount = void 0;
const Application_ts_1 = require("./Application.js");
/**
 * Patient-side HDS account wrapper.
 *
 * Post-plan-61 Phase C, the patient flow is CMC-only:
 * - Incoming invites are accepted via `cmc.acceptInvite`
 * - Active relationships are read via `cmc.listAcceptedRelationships` +
 *   the patient's local counterparty accesses, aggregated into Contacts
 *   by `Contact.aggregateCmc()`
 *
 * AppClientAccount now provides only the base `Application` surface
 * (init, connection, baseStreamId) — no legacy CollectorClient lifecycle.
 * Useful primarily as the target of `HDSSettings.hookToApplication()`.
 */
class AppClientAccount extends Application_ts_1.Application {
    // No `mustBeMaster`: a scoped `app` access with manage on the base stream is enough (B-2026-10-07-6).
    get appSettings() {
        return {
            canBePersonnal: true
        };
    }
}
exports.AppClientAccount = AppClientAccount;
